import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-factory-stake-token',
  templateUrl: './factory-stake-token.component.html',
  styleUrls: ['./factory-stake-token.component.css']
})
export class FactoryStakeTokenComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
